/* eslint-disable @typescript-eslint/no-explicit-any */
export class DiffUtils {
  static diffObjectsWith(config1: unknown, config2: unknown, cb: (p1: unknown, p2: unknown) => unknown) {
    // If both are arrays, iterate and compare each index
    if (Array.isArray(config1) && Array.isArray(config2)) {
      const result = config1?.reduce((acc, val, idx) => {
        if (typeof val === 'object' && val !== null) {
          const nestedDiff = this.diffObjectsWith(val, config2[idx], cb);
          return nestedDiff && Object.keys(nestedDiff).length ? [...acc, nestedDiff] : acc;
        }
        return cb(val, config2[idx]) ? [...acc, val] : acc;
      }, []);
      return result.length ? result : undefined;
    }

    // If both are objects, compare properties
    if (typeof config1 === 'object' && config1 !== null && typeof config2 === 'object' && config2 !== null) {
      return Object.keys(config1).reduce((acc, key) => {
        const val1 = (config1 as any)[key];
        const val2 = (config2 as any)[key];

        // Recursively compare nested objects/arrays
        if (typeof val1 === 'object' && val1 !== null) {
          const nestedDiff = this.diffObjectsWith(val1, val2, cb);
          return nestedDiff && Object.keys(nestedDiff).length ? { ...acc, [key]: nestedDiff } : acc;
        }

        // Compare scalar values
        return cb(val1, val2) ? { ...acc, [key]: val1 } : acc;
      }, {});
    }

    // Compare scalars directly
    return cb(config1, config2) ? config1 : undefined;
  }
}
